import React, { useEffect, useState } from 'react';
import { View, StyleSheet, ScrollView, useWindowDimensions } from 'react-native';
import Text from '../../components/text';
import drawerHoc from '../../components/drawerHOC/DrawerHOC';
import CompactAccountSection from './CompactAccountSection';
import DepositManagementModal from '../tenants/tenantOnboarding/screens/modals/depositManagementModal';
import { TenantService } from '../tenants/redux/tenant.service';
import { useIsFocused } from '@react-navigation/native';
import DeletePopUp from '../tenants/tenantOnboarding/screens/modals/deletePopUp';
import { showErrorToast, showSuccesToast } from '../tenants/tenantOnboarding/helpers';
import { COLORS, BORDER_RADIUS, SHADOWS } from '../../constants/theme';

const HubFlow = () => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 767;

  const [tdsAccount, settdsAccount] = useState({
    branch_id: '',
    member_id: '',
    api_key: '',
  });
  const [sdsAccount, setsdsAccount] = useState({
    branch_id: '',
    member_id: '',
    api_key: '',
  });
  const [tdsNiAccount, setTdsNiAccount] = useState({
    branch_id: '',
    member_id: '',
    api_key: '',
  });

  const focused = useIsFocused();

  useEffect(() => {
    FetchData();
  }, [focused]);

  const FetchData = () => {
    TenantService.getTDSSDSACCOUNT()
      .then((response) => {
        if (response?.data?.sds?.has_sds_protection) {
          setsdsAccount(response?.data?.sds);
        } else {
          setsdsAccount({ branch_id: '', member_id: '', api_key: '' });
        }
        if (response?.data?.tds?.has_tds_protection) {
          settdsAccount(response?.data?.tds);
        } else {
          settdsAccount({ branch_id: '', member_id: '', api_key: '' });
        }
        if (response?.data?.tds_ni?.has_tds_ni_protection) {
          setTdsNiAccount(response?.data?.tds_ni);
        } else {
          setTdsNiAccount({ branch_id: '', member_id: '', api_key: '' });
        }
      })
      .catch((err) => {
        console.log('getTDSSDSACCOUNT err', err);
      });
  };

  const [showDeleteModal, setShowDeleteModal] = useState<any>({
    show: false,
    type: '',
  });

  const [showDepositAccountModal, setShowDepositAccountModal] = useState<any>({
    show: false,
    type: '',
    mode: '',
  });

  return (
    <ScrollView style={[styles.container, isMobile && styles.containerMobile]} showsVerticalScrollIndicator={false}>
      {/* Breadcrumb Header */}
      <Text style={styles.breadcrumbText}>Settings › Property Management › Deposit Custody</Text>

      <View style={styles.headerRow}>
        <Text style={styles.pageTitle}>Deposit Management (HubFlow)</Text>
      </View>

      {/* Top Notice Alert Banner matching Figma */}
      <View style={styles.noticeBanner}>
        <Text style={styles.noticeTitle}>Direct Custodial Protection Integration</Text>
        <Text style={styles.noticeBody}>
          Directly synchronize secure tenancy protection deposits directly to designated government schemes.
          Simply verify credentials to enable tlyfePro integrations. For setup guidance, email{' '}
          <Text style={styles.emailLink}>support@openbrix.co.uk</Text> for aid.
        </Text>
      </View>

      {/* Custodial Accounts List */}
      <View style={styles.accountsWrapper}>
        <CompactAccountSection
          title="TDS Account"
          subtitle="Tenancy Deposit Scheme Custodial"
          account={tdsAccount}
          onEdit={() => setShowDepositAccountModal({ show: true, type: 'edit', mode: 'TDS' })}
          onDelete={() => setShowDeleteModal({ show: true, type: 'tds' })}
          onLink={() => setShowDepositAccountModal({ show: true, type: 'add', mode: 'TDS' })}
        />

        <CompactAccountSection
          title="SDS Account"
          subtitle="Safe Deposits Scotland Integration Channel"
          account={sdsAccount}
          onEdit={() => setShowDepositAccountModal({ show: true, type: 'edit', mode: 'SDS' })}
          onDelete={() => setShowDeleteModal({ show: true, type: 'sds' })}
          onLink={() => setShowDepositAccountModal({ show: true, type: 'add', mode: 'SDS' })}
        />

        <CompactAccountSection
          title="TDS (Northern Ireland) Account"
          subtitle="Northern Ireland Tenancy Deposit Scheme"
          account={tdsNiAccount}
          onEdit={() => setShowDepositAccountModal({ show: true, type: 'edit', mode: 'TDS_NI' })}
          onDelete={() => setShowDeleteModal({ show: true, type: 'tds_ni' })}
          onLink={() => setShowDepositAccountModal({ show: true, type: 'add', mode: 'TDS_NI' })}
        />
      </View>

      {/* Modal 1: Link/Edit Account Modal */}
      {showDepositAccountModal.show ? (
        <DepositManagementModal
          open={showDepositAccountModal.show}
          handleClose={() => setShowDepositAccountModal({ show: false, type: '', mode: '' })}
          type={showDepositAccountModal.type}
          mode={showDepositAccountModal.mode}
          initialData={
            showDepositAccountModal.mode === 'TDS'
              ? tdsAccount
              : showDepositAccountModal.mode === 'TDS_NI'
              ? tdsNiAccount
              : sdsAccount
          }
          onSubmit={(payload: any) => {
            TenantService.linkSdsAccount(payload)
              .then(() => {
                showSuccesToast(`${showDepositAccountModal.mode} Account linked successfully!`);
                FetchData();
              })
              .catch(() => {
                showErrorToast('Something went wrong!');
              });
            setShowDepositAccountModal({ show: false, type: '', mode: '' });
          }}
        />
      ) : null}

      {/* Modal 2: Delete Account Popup */}
      <DeletePopUp
        showModal={showDeleteModal?.show}
        onClose={() => setShowDeleteModal({ show: false, type: '' })}
        title={'Are you sure you want to delete these deposit credentials?'}
        onSubmit={() => {
          TenantService.deletelinkAccount(showDeleteModal?.type)
            .then(() => {
              showSuccesToast('Account deleted successfully!');
              FetchData();
              setShowDeleteModal({ show: false, type: '' });
            })
            .catch(() => {
              showErrorToast('Something went wrong!');
              setShowDeleteModal({ show: false, type: '' });
            });
        }}
      />
    </ScrollView>
  );
};

export default drawerHoc({
  Component: HubFlow,
  showBackButton: true,
  backNavigation: 'Setting',
});

/* ================= STYLES ================= */

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: COLORS.appBg,
  },
  containerMobile: {
    padding: 14,
  },

  breadcrumbText: {
    fontSize: 12,
    color: '#9CA3AF',
    marginBottom: 6,
  },

  headerRow: {
    marginBottom: 18,
  },

  pageTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: COLORS.textPrimary,
  },

  /* NOTICE BANNER */
  noticeBanner: {
    backgroundColor: '#F5F3FF',
    borderWidth: 1,
    borderColor: '#E0E7FF',
    borderRadius: BORDER_RADIUS.lg,
    padding: 16,
    marginBottom: 20,
  },
  noticeTitle: {
    fontSize: 13,
    fontWeight: '700',
    color: '#6C2BD9',
    marginBottom: 4,
  },
  noticeBody: {
    fontSize: 12,
    color: '#4B5563',
    lineHeight: 18,
  },
  emailLink: {
    color: '#6C2BD9',
    fontWeight: '600',
  },

  accountsWrapper: {
    marginBottom: 40,
  },
});